module fdm.pilotPerformance {

    export class PilotPerformanceService {


        public constructor(
            private actionService: dg.actions.ActionService) {

        }
    }

    angular.module('fdm.pilotPerformance')
        .service('pilotPerformanceService', PilotPerformanceService);
}